export const PAGE_OPTIONS = [20, 50, 100];

export enum ACTIONS {
  FIRST = 'FIRST',
  LAST = 'LAST',
  NEXT = 'NEXT',
  PREV = 'PREV',
}
